<template>
  <authorization permissionKey="attendance_surgery_indication" can="read">
    <v-container fluid>
      <v-row>
        <v-col cols="auto" class="text-h3 gray--text"> 
          Indicações Cirurgicas 
        </v-col>
        <v-col cols="auto">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                v-on="on"
                :attrs="attrs"
                :to="`/pacientes/${attendance.patient.id}/cirurgias`"
              >
                <v-icon>eva-file-outline</v-icon>
              </v-btn>
            </template>
            <span>Histórico</span>
          </v-tooltip>
        </v-col>

        <v-spacer />
        <authorization
          permissionKey="attendance_surgery_indication"
          can="save"
          v-slot:default="{ authorization }"
        >
          <v-col cols="auto" v-if="authorization">
            <v-btn
              color="light-blue"
              :dark="!attendanceEsigned"
              :to="`/prontuario/${attendance.id}/indicacao-cirurgica/nova`"
              :disabled="attendanceEsigned"
            >
              Adicionar
            </v-btn>
          </v-col>
        </authorization>
      </v-row>

      <SurgeryIndicationList
        :attendance="attendance"
        :disabled="attendanceEsigned"
      />
    </v-container>
  </authorization>
</template>

<script>
import SurgeryIndicationList from "@/components/surgery_indication/list/index.vue";

export default {
  name: "SurgeryIndications",
  props: {
    attendance: Object,
    attendanceEsigned: Boolean,
  },
  components: {
    SurgeryIndicationList,
  },
};
</script>

<style lang="scss" scoped></style>
